import {useState} from "react";
import {App} from "antd";
import Button from "../Button";
import FontAwesomeIcon from "../FontAwesome";
import {useGetMySubscriptionQuery} from "~/reduxs/api/subscriptionApiSlice";
import {exportExcel, exportPdf} from "~/utils/exportReport";

/**
 * Nút "Xuất Excel / PDF" dùng chung — gate theo cờ gói (`features.export_excel`/`export_pdf`
 * từ subscription/me; root → mọi cờ true). Nếu gói không có quyền nào → không hiện gì.
 *
 * Props:
 *  - filename: tên file (không cần đuôi).
 *  - buildExcel(): trả [{name, aoa}] — gọi LÚC bấm để lấy dữ liệu mới nhất.
 *  - buildPdf():  trả {title, subtitle?, sections:[{heading?, columns, rows}]}.
 * Bỏ prop tương ứng nếu không hỗ trợ định dạng đó.
 */
function ExportButtons({filename = 'bao-cao', buildExcel, buildPdf, small = true}) {
	const {notification} = App.useApp();
	const {data: sub} = useGetMySubscriptionQuery();

	const feats    = sub?.features || {};
	const canExcel = !!feats.export_excel && typeof buildExcel === 'function';
	const canPdf   = !!feats.export_pdf && typeof buildPdf === 'function';

	const [busy, setBusy] = useState(null);

	if (!canExcel && !canPdf) return null;

	const run = async (type) => {
		try {
			setBusy(type);
			if (type === 'excel') await exportExcel(filename, buildExcel());
			else await exportPdf(filename, buildPdf());
		} catch (e) {
			notification.error({message: 'Xuất báo cáo thất bại', description: e?.message || 'Vui lòng thử lại.'});
		} finally {
			setBusy(null);
		}
	};

	return (
		<div style={{display: 'inline-flex', gap: 8, flexWrap: 'wrap'}}>
			{canExcel && (
				<Button white small={small} loading={busy === 'excel'} disabled={!!busy}
					onClick={() => run('excel')} leftIcon={<FontAwesomeIcon icon="fa-light fa-file-excel" />}>
					Xuất Excel
				</Button>
			)}
			{canPdf && (
				<Button white small={small} loading={busy === 'pdf'} disabled={!!busy}
					onClick={() => run('pdf')} leftIcon={<FontAwesomeIcon icon="fa-light fa-file-pdf" />}>
					Xuất PDF
				</Button>
			)}
		</div>
	);
}

export default ExportButtons;
